@if (context$ | async) {
  <elder-single-pane-wrapper class="full">
    <elder-pane-header>
      <elder-pane-title>{{ 'layout.connection' | translate }}</elder-pane-title>
    </elder-pane-header>
    <elder-pane-content>
      <form class="flex layout-col p-md">
        <div class="flex layout-row p-xl place-between-start">
          <!-- Source -->
          <div class="layout-col">
            <h4 elderpaneSubtitle>{{ 'layout.source' | translate }}</h4>
            <mat-chip-set>
              <mat-chip highlighted>{{
                source?.workCenter?.number + ' ' + source?.workCenter?.name
              }}</mat-chip>
            </mat-chip-set>
          </div>
          <!-- Weight -->
          <div class="layout-col">
            <h4 elderpaneSubtitle>{{ 'layout.transport-duration' | translate }}</h4>
            <div class="layout-row gap-md">
              <mat-form-field subscriptSizing="dynamic">
                <elder-duration-input
                  name="transport-duration"
                  [placeholder]="'Initial'"
                  [isoValue]="edge?.transportCost?.duration"
                  (valueChange)="onDurationChange($event)"
                  [format]="'hh:mm'"
                ></elder-duration-input>
                <mat-error elderValidationError></mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Target -->
          <div class="layout-col">
            <h4 elderpaneSubtitle>{{ 'layout.target' | translate }}</h4>
            <mat-chip-set>
              <mat-chip highlighted>{{
                target?.workCenter?.number + ' ' + target?.workCenter?.name
              }}</mat-chip>
            </mat-chip-set>
          </div>
        </div>
        <div class="flex-none layout-row place-end-stretch">
          <button mat-button (click)="onClose()">
            {{ 'actions.cancel' | translate }}
          </button>
          <button mat-button (click)="onDelete()">
            {{ 'actions.delete' | translate }}
          </button>
          <button mat-button (click)="onApply()">
            {{ 'actions.apply' | translate }}
          </button>
        </div>
      </form>
    </elder-pane-content>
  </elder-single-pane-wrapper>
}
